/**
 * Cross-tab propagation of "milestone chat read" state.
 *
 * Marking a milestone chat as seen is a fire-and-forget HTTP call that only
 * updates the tab that performed it. Other open tabs keep showing a stale
 * unread indicator until a manual refresh. The reading tab broadcasts the
 * milestone id, and every other tab re-emits it onto the in-tab event bus as
 * `milestone-chat-seen` so components can clear their own indicators via
 * `eventBusCallbacks`.
 */
import { createCrossTabChannel } from 'source/lib/crossTabChannel.js';

const channel = createCrossTabChannel('milestone-chat-seen', 'milestone-chat-seen');

/**
 * Start listening for cross-tab "milestone chat read" broadcasts. Called once
 * at app startup so a tab can receive broadcasts even if it never marks a chat
 * as read itself.
 */
export function initMilestoneChatSeenChannel() {
    channel.init();
}

/**
 * Notify other tabs that the given milestone's chat has been read.
 *
 * @param {number | string} milestoneId - The milestone whose chat was seen.
 */
export function broadcastMilestoneChatSeen(milestoneId) {
    if (milestoneId == null) return;
    channel.broadcast({ milestoneId: Number(milestoneId) });
}
